<template>
  <div class="question-set-card" style="padding-bottom: 1.25rem;">
    <div>
      <div class="question-set-card--name">{{ questionSet.name | translate | summary }}</div>
      <i class="bx bxs-school align-middle"></i>
      {{ questionSet.firm.name | translate | summary }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    questionSet: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      checked: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.question-set-card {
  width: 100%;
  flex-shrink: 0;
  border-radius: 0.5rem;
  border: 1px solid #e5e7f0;
  background: #fcfcff;
  padding: 1.25rem;
  padding-bottom: 0.75rem;
  margin-bottom: 1rem;
}

.question-set-card--name {
  color: #383a55;
  font-family: "Roboto";
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
</style>
